import { useContext } from 'react';
import UserContext from 'modules/common/context/UserContext';
import { PROOFER_USER_GROUP } from 'modules/common/constants';

export function useIsProoferRole() {
  const { userGroups } = useContext(UserContext);

  return userGroups?.includes(PROOFER_USER_GROUP);
} 